import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'


//constants
import { Constants }         from '../../constants/Constants';

import { CustomerGridComponent } from '../../components/Grids/CustomerGrid.component';
import { map } from 'rxjs/operators';


@Component({
  selector: 'my-select-payer',
  templateUrl: './SelectPayer.component.html'
})
export class SelectPayerComponent implements OnInit {

    
    public displayDialog: boolean;

    @ViewChild(CustomerGridComponent) customerGridComponent: CustomerGridComponent;

    @Output() public yesClick: EventEmitter<any> = new EventEmitter();
    @Output() public cancelClick: EventEmitter<any> = new EventEmitter();
    @Output() onCustomerSelected = new EventEmitter<ent.Customer>();

    noRecords: boolean = false;

    constructor(private customerService: serv.CustomerService) 
    {

    }

    getPayers(request: ent.GetPayersRequest) : Observable<ent.Customer[]>{
        
        const response = this.customerService.getPayers(request).pipe(map(result => {
            
            this.customerGridComponent.records = result;
            this.noRecords = result.length == 0;
            return result;
        }));
        return response;
    }

    ngOnInit(): void {
    }

    onHide(){
        this.displayDialog = false;
    }

    onCancelClick(event: any){
        this.cancelClick.emit(null);
        this.displayDialog = false;
    }

    customerSelected(customer: ent.Customer) {
        this.onCustomerSelected.emit(customer);
    }
}